import { render } from "./FlashActions.vue?vue&type=template&id=856b0ec6&scoped=true"
import script from "./FlashActions.vue?vue&type=script&lang=js"
export * from "./FlashActions.vue?vue&type=script&lang=js"

import "./FlashActions.vue?vue&type=style&index=0&id=856b0ec6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-856b0ec6"],['__file',"src/components/FlashActions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "856b0ec6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('856b0ec6', __exports__)) {
    api.reload('856b0ec6', __exports__)
  }
  
  module.hot.accept("./FlashActions.vue?vue&type=template&id=856b0ec6&scoped=true", () => {
    api.rerender('856b0ec6', render)
  })

}


export default __exports__